"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const use_impression_observer_1 = tslib_1.__importDefault(require("./use-impression-observer"));
const use_analytics_1 = require("../../use-analytics");
function useTrackComponent({ onCreateImpressionWhenView, onImpressionTrackEvent, onClickTrackEvent, context, }) {
    const analytics = (0, use_analytics_1.useAnalytics)(context);
    const maybeTrackEvents = (events) => {
        if (events) {
            for (const event of Array.isArray(events) ? events : [events]) {
                analytics.trackEvent(event);
            }
        }
    };
    const { inViewRef } = (0, use_impression_observer_1.default)({
        onCreateImpressionWhenView: (data) => {
            onCreateImpressionWhenView?.(data);
            maybeTrackEvents(onImpressionTrackEvent?.(data));
        },
    });
    const onClick = (e) => {
        maybeTrackEvents(onClickTrackEvent?.(e));
    };
    return { inViewRef, onClick };
}
exports.default = useTrackComponent;
//# sourceMappingURL=use-track-component.js.map